export function MXSpaceSetupGuide() {
    return (
        <div style={{ display:'flex', justifyContent:'center', padding : "30px 0"}}>
            <img src="/images/setupGuide.gif" width="100%" height="auto" style={{maxWidth:'620px'}}/>
        </div>
    )
}